import Service from "../Service";
import Vue from "vue";
const resource = "AdvanceProducer/";

export default {
  pagination(parameters, requestID) {
    // console.log('Pafination', parameters, requestID);
    return Service.post(resource + "pagination", parameters, {
      params: { requestID },
    });
  },
  save(advanceProducer, requestID) {
    return Service.post(resource + "save", advanceProducer, {
      params: { requestID },
    });
  },
  byID(parameters, requestID) {
    return Service.post(resource + "byId", parameters, {
      params: { requestID },
    });
  },
  getAdvanceProducerDetails(parameters, AdpID, requestID) {
    return Service.post(resource + "Details", parameters, {
      params: { requestID, AdpID },
    });
  },
  saveOrUpdateDetail(parameters, requestID) {
    return Service.post(resource + "SaveItemDetail", parameters, {
      params: { requestID },
    });
  },
  users(parameters, requestID) {
    return Service.post(resource + "user", parameters, {
      params: { requestID },
    });
  },
  getCircuits(parameters, requestID) {
    return Service.post(resource + "getCircuits", parameters, {
      params: { requestID },
    });
  },
  getResponsibles(parameters, requestID) {
    return Service.post(resource + "getResponsibles", parameters, {
      params: { requestID, ...parameters },
    });
  },

  saveListAttachment(list, requestID) {
    return Service.post(resource + "saveListAttachment", list, {
      params: { requestID: requestID },
    });
  },

  listTasAdvanceProducerAttachment(AdpID, requestID) {
    return Service.get(resource + "listTasAdvanceProducerAttachment", {
      params: { AdpID: AdpID, requestID: requestID }
    });
  },
  getAdvanceProducerFarmLots(parameters, AdpID, requestID) {
    return Service.post(resource + "FarmLots", parameters, {
      params: { requestID, AdpID },
    });
  },
  syncSAP(AdpID, requestID, bankAccount = "") {
    return Service.post(resource + "SyncSAP", {}, {
      params: { requestID, AdpID, bankAccount },
    });
  },
  getBankAccounts(requestID) {
    return Service.get(resource + "BankAccounts", {
      params: { requestID },
    });
  },

  InputPurchaseForecast(parameters, requestID) {
    return Service.post(resource + "InputPurchaseForecast", parameters, {
      params: { requestID },
    });
  },


  getUrlFarmSupervisorbyProducer() {
    return Vue.prototype.$http.defaults.baseURL + "/AdvanceProducer/FarmSupervisorbyProducer";
  },

  FarmbyProducer(PrdID, CmaID, requestID) {
    return Service.post(resource + "FarmbyProducer", {}, {
      params: { PrdID: PrdID, CmaID: CmaID, requestID: requestID },
    });
  },

  AdvanceProducerProducerDebt(PrdID, requestID) {
    return Service.post(resource + "AdvanceProducerProducerDebt", {}, {
      params: { PrdID: PrdID, requestID: requestID },
    });
  },

  SummaryFreshReceiptJabas(CmaID, FltIDS, requestID) {
    return Service.post(resource + "SummaryFreshReceiptJabas", {}, {
      params: { CmaID: CmaID, FltIDS: FltIDS, requestID: requestID },
    });
  },

  PaginationReport(parameters, requestID) {
    return Service.post(resource + "PaginationReport", parameters, {
      params: { requestID },
    });
  },

  PurchasePricebyProducer(CmaID, PrdID, FltID, requestID) {
    return Service.post(resource + "PurchasePricebyProducer", {}, {
      params: { CmaID: CmaID, PrdID: PrdID, FltID: FltID, requestID: requestID },
    }); 
  },

  SupplyAdvancePaymentReport(BeginDate,EndDate, PrdID, AdpID, DocEntry, requestID) {
    return Service.post(resource + "SupplyAdvancePaymentReport", {}, {
      params: { BeginDate: BeginDate, EndDate: EndDate, PrdID: PrdID, AdpID: AdpID, DocEntry: DocEntry, requestID: requestID },
    }); 
  },

  SupplyMoneyAdvancePaymentReport(PrdID, AdpID, DocEntry, requestID) {
    return Service.post(resource + "SupplyMoneyAdvancePaymentReport", {}, {
      params: { PrdID: PrdID, AdpID: AdpID, DocEntry: DocEntry, requestID: requestID },
    }); 
  },
  ProducerTotalDebtSAP(PrdID, requestID) {
    return Service.post(resource + "ProducerTotalDebtSAP", {}, {
      params: { PrdID: PrdID, requestID: requestID },
    }); 
  },
};
